import React from 'react';
import SolutionPageLayout from '../../components/solutions/SolutionPageLayout';
import { SOLUTIONS } from '../../data/solutions';

const SystemIntegrationsPage: React.FC = () => (
  <SolutionPageLayout content={SOLUTIONS.integrations} />
);

export default SystemIntegrationsPage;
